export class EmergencyContact {
  Id: number;
  IsPrimary: boolean;
  FullName: string;
  Relationship: string;
  PhoneNumber: string;
}
